<template>
    <div>
        <!-- TABELA-INICIAL -->
        <v-layout v-if="!selectedCategory" justify-center wrap row py-5>
            <v-flex xs12 md8>
                <v-card>
                    <v-card-title>
                        <v-layout row wrap justify-center>
                            <v-flex xs7>
                                <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="categories" :search="search">
                        <template v-slot:items="props">
                            <td>{{ props.item.title }}</td>
                            <td class="justify-center layout">
                                <v-icon @click="editItem(props.item)">visibility</v-icon>
                            </td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert
                                :value="true"
                                color="error"
                                icon="warning"
                            >Your search for "{{ search }}" found no results.</v-alert>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <!-- TABELA-INIICAL -->

        <v-layout v-else wrap row>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click.prevent="cancelNewContract();" title="Cancelar">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Estoque</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn title="Salvar Contrato" color="primary" small depressed>
                        Salvar
                        <v-icon right>save</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-container fluid grid-list-xl>
                <stock-table></stock-table>
            </v-container>
        </v-layout>

        <!-- DIALOG LOADING -->
        <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Carregando
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- DIALOG LOADING -->
    </div>
</template>

<script>
// SERVICES //

import UtilService from '../service/UtilService.js'
import UtilFormatter from '../utils/UtilFormatter.js'
import MessageFormatterUtil from '../utils/MessageFormatterUtil.js'

//COMPONENTS
import AlertDelete from './../components/AlertDelete'
import StockTable from './../components/StockTable'

export default {
    components: {
        AlertDelete,
        StockTable,
    },

    data() {
        return {
            quantityItemsError: false,
            firstAccess: true,
            dialogLoading: false,
            utilFormatter: UtilFormatter,
            selectedCategory: true,
            isEditing: false,
            listItems: [],

            // ALERT //
            msgAlert: '',
            alertType: '',
            alert: false,
            removeDialog: false,
            // TABELA //
            loading: false,
            emptyRecordsText: 'Nenhum registro encontrado',
            emptySearchText: 'Nenhum registro encontrado para',
            editingSheet: {},
            pagination: {
                sortBy: 'description',
                descending: true,
            },
            headers: [
                { text: 'Categorias', value: 'title' },
                { text: 'Ações', value: 'actions', align: 'center' },
            ],
            search: '',
            categories: [
                {
                    title: 'Materiais de Consumo',
                    type: 'Material de Consumo',
                    value: 'consumables',
                },
                {
                    title: 'Equipamentos',
                    type: 'Equipamento',
                    value: 'equipment',
                },
                { title: 'Utensílios', type: 'Utensílio', value: 'utensil' },
                {
                    title: "Uniformes e EPI's",
                    type: "Uniforme e EPI's",
                    value: 'uniformAndEPI',
                },
            ],
        }
    },

    methods: {
        //###########################PAGINA###########################//

        init() {
            this.alert = false
            this.loading = false
            this.isEditing = false
            this.dialogLoading = true
            this.selectedCategory = false
            this.dialogLoading = false
            this.quantityItemsError = false
            this.editingSheet = {}
        },

        amountCalculate(item) {
            let amount = 0
            if (this.depreciation == 'true') {
                amount = item.quantity * item.value * (item.lifetime / 100)
            } else {
                amount = (item.quantity * item.value) / item.lifetime
            }
            return amount
        },

        showAlert(message, type) {
            this.msgAlert = message
            this.alertType = type
            this.alert = true
        },

        async openWindowStock() {
            this.dialogLoading = true
            if (this.firstAccess) {
                //await Products(type)
                this.firstAccess = false
                this.dialogLoading = false
                this.selectedCategory = true
            } else {
                this.dialogLoading = false
                this.selectedCategory = true
            }
        },
        cancelNewContract() {
            this.init()
        },

        editItem(item) {
            this.isEditing = true
            this.listItems = Object.assign({}, item)
            this.openWindowStock()
        },

        async save() {
            this.dialogLoading = true
            try {
                /*  if (this.isEditing) {
                    await ContractService.update(this.contract)
                    this.showAlert('Registro alterado com sucesso', 'success')
                } else {
                    await ContractService.create(this.contract)
                    this.showAlert('Registro salvo com sucesso', 'success')
                } */
            } catch (error) {
                /* this.showAlert('Erro ao salvar o contrato', 'error')
                console.log(error) */
            } finally {
                this.dialogLoading = false
            }
            this.init()
        }, //save()
    },
    beforeMount() {
        this.init()
    },
}
</script>

<style>
.descoration {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Stock.vue